import QuizController from '../quiz-shared/quiz-controller';

const SELECTOR = '.wp-block-improntad-theme-blocks-quiz.quiz';

function init() {
  document.querySelectorAll(SELECTOR).forEach((el) => new QuizController(el));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
